<template>
  <div class="v-login-poster" :style="bgImg">
    <div class="v-login-poster__head">
      <div class="v-login-poster__logo"></div>
    </div>
  </div>
</template>

<script>
import utilsImg from '@3vjia/v-utils/src/img';

export default {
  name: 'v-login-poster',
  props: {
    img: { type: String, default: '' },
  },
  computed: {
    bgImg() {
      return `background-image: url(${utilsImg.webpFormat(utilsImg.resizeFormat(this.img, 660, 600, 'fill', true), true)})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-login-poster {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-indent: -9999px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
}
.v-login-poster__head {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 70px;
  background: linear-gradient(180deg,rgba(0,0,0,0.4) 0%,rgba(0,0,0,0) 100%);
}
.v-login-poster__logo {
  margin-left: 20px;
  margin-top: 18px;
  width: 63px;
  height: 32px;
  background: url('../imgs/logo.png') center no-repeat;
  background-size: 60px auto;
}
</style>
